import React, { useEffect } from "react";
import Login from "./pages/login/Login";
import { useDispatch, useSelector } from "react-redux";
import RadRoutes from "./pages/components/A02_RadRoutes";
import styled from "styled-components";
import MessageReminder from "./pages/components/MessageReminder";
import WebSocketUser from "./pages/login/WebSocketUser";
import { setMousePos, setScroll } from "./features/ScrollTracking";
import { createContext } from "react";
import { useState } from "react";
import { decode, encode } from "js-base64";
import { checkUser } from "./features/CheckUser";
import { login, setCurAuthen } from "./features/UserProfie";
import { PrefixService } from "./model/prefix";
import { FormatThaiCard3, MysqlDateCV } from "./core/Helper";
import useWebSocket from "react-use-websocket";

export const WsContext = createContext();
export const WsCmmdContext = createContext();
export const PersonInfoContext = createContext();
export const CardReadCommandContext = createContext();

// import image from "../images/radiologist-group.jfif";
export default function App() {
  //** Parameter from query string */
  //** Used when open case from another applicatin such as 'Line PC' */
  const queryParams = window.location.search;

  //** มีการขอเปิดภาพจาก link ภายใน */

  //console.log(queryParams);

  if (queryParams) {
    const info = new URLSearchParams(queryParams).get("info");
    //* have line login request message show
    const lineCode = new URLSearchParams(queryParams).get("code");
    const lineState = new URLSearchParams(queryParams).get("state");
    // console.log(info);
    /** 1. Get parameters info
     *  2. Use 'Session Storage' => goto 'RadioWorklist' or 'TechWorklist'
     *     to detects a request from external web link
     */
    if (info) {
      const decInfo = decode(info);

      // debugging
      // console.log(decInfo);

      let subInfo = decInfo.split(/&/);
      if (subInfo.length > 0) {
        subInfo.map((a) => {
          let itemA = a.split(/=/);
          sessionStorage.setItem(itemA[0], itemA[1]);
        });
      }
    }

    if (lineCode && lineState) {
      sessionStorage.setItem(
        "line_login_register_request_state",
        decode(lineState.substring(10)),
      );
      sessionStorage.setItem("line_login_register_request_code", lineCode);
    }
  }

  const dispatch = useDispatch();
  //** ตัวแปรเก้บ web-socket กับ command-socket */
  const wsState = useState(null);
  const wsCmmdMessage = useState(null);
  const user = useSelector((state) => state.user);

  const theme = useSelector((s) => {
    return s.theme.theme;
  });

  const [personInfo, setPersonInfo] = useState(null);
  //** varible to enable text selection by mouse_doubleclick */
  const [mouseText, setMouseText] = useState(false);

  //** prefix */
  const convertPrefix = async (text) => {
    let ret = await PrefixService.GetItemsByText({ text: text }, user.detail);

    if (ret?.length > 0)
      return { PrefixId: ret?.[0]?.PrefixID, PrefixText: ret?.[0].PrefixText };
  };

  const getPersonInfo = async (info) => {
    let person = JSON.parse(info?.data);
    // console.log(person);
    let thaiPrefix = await convertPrefix(person.Th_Prefix);
    let engPrefix = await convertPrefix(person.En_Prefix);

    setPersonInfo((pv) => ({
      ...pv,
      IdCardNo: FormatThaiCard3(person?.Citizenid),
      Prefix: thaiPrefix,
      Firstname: person?.Th_Firstname,
      Lastname: person?.Th_Lastname,
      PrefixEn: engPrefix,
      FirstnameEng: person?.En_Firstname,
      LastnameEng: person?.En_Lastname,
      Addr:
        person?.addrHouseNo +
        " " +
        person?.addrVillageNo +
        " " +
        person?.addrTambol,
      Addr2: person?.addrAmphur + " " + person?.addrProvince,
      BirthDate: MysqlDateCV(person.Birthday),
      Gender: { GenderId: Number(person.Sex) },
    }));
  };

  const wssRes = {
    onOpen: (e) => {
      console.log("card reader connecting..", e);
    },
    onMessage: getPersonInfo,
    onClose: (e) => {},
    onError: (e) => {},
    shouldReconnect: (e) => true,
    reconnectAttemps: 300000,
    reconnectInterval: 300000,
  };

  const cardReaderCommand = useWebSocket(
    "ws://127.0.0.1:8800/EchoAll?username=test&password=1234&session_type=3&secure=n",
    wssRes,
  );

  // remove mouse event first from 'RadioResult'
  const updateMouseEvent = (e) => {
    document.removeEventListener("mousedown", mouseDownEvt);
    setMouseText(e.detail.action);
  };

  //** mousedonw event listener */
  useEffect(() => {
    document.addEventListener("mousedown", mouseDownEvt);
  }, [mouseText]);

  const mouseDownEvt = (e) => {
    if (e.detail > 1) {
      if (!mouseText) {
        // console.log("prevented...!!");
        e.preventDefault();
      }
    }
  };

  useEffect(() => {
    const onScroll = (e) => {
      dispatch(setScroll({ scTop: window.scrollY, scLeft: window.scrollX }));
    };
    const onMouseMove = (e) => {
      // console.log(e);
      dispatch(setMousePos({ x: e.screenX, y: e.screenY }));
    };

    // event to check/update text selection by mouse double_click
    document.addEventListener("mouse_event_update", updateMouseEvent);

    // *** clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });

    window.addEventListener("mousemove", onMouseMove);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("mousemove", onScroll);
      document.removeEventListener("mouse_event_update", updateMouseEvent);
    };
  }, [mouseText]);

  //** Login by-passed */
  const startPage = () => {
    return (
      <WorkContainer data-theme={theme.themeName}>
        <WsContext.Provider value={wsState}>
          <WsCmmdContext.Provider value={wsCmmdMessage}>
            <PersonInfoContext.Provider value={personInfo}>
              <CardReadCommandContext.Provider value={cardReaderCommand}>
                <RadRoutes />
              </CardReadCommandContext.Provider>
            </PersonInfoContext.Provider>
            {/* เชื่อมต่อ web socket server */}
            {user.detail.ws_enable_flag === "y" ? <WebSocketUser /> : <></>}
            <MessageReminder />
          </WsCmmdContext.Provider>
        </WsContext.Provider>
      </WorkContainer>
    );
  };

  //** Login */
  const startLogin = () => {
    return (
      <LoginContainer data-theme={theme.themeName}>
        <BgCover>
          <BgImage src="images/radiologist-group.jfif" />
          <BgOverlay />
          <MessageReminder />
        </BgCover>
        <Login />
      </LoginContainer>
    );
  };

  //localStorage.removeItem("raduser");

  if (!user.userStatus.authen) {
    //**Check Rad saved user */
    let savedUser = localStorage.getItem("raduser");
    if (savedUser != null) {
      const getUser = async () => {
        let k = decode(savedUser);
        let m = k.split("XvEz");
        let u = await checkUser(m[0], m[1]); //**m1=usename, m2=password */
        dispatch(login(u));
        dispatch(setCurAuthen({ username: m[0], password: encode(m[1]) }));
        return startPage();
      };
      getUser();
    } else {
      //** Login */
      return startLogin();
    }
  } else {
    //** เริ่มหน้า home  */
    return startPage();
  }
}

const LoginContainer = styled.div`
  /* display: flex;
  /* border: 5px solid red; */
  /* flex-direction: column;
  justify-content: center;
  align-items: center; */
  /* width: auto; */
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;  */

  /* border: 1px solid red;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1; */

  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #070a12;
  overflow: hidden;
  position: relative;

  /* background-image: url("/images/radiologist-group.jfif"); */
`;

const BgCover = styled.div`
  border: 1px solid red;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const BgImage = styled.img`
  src: url("/images/radiologist-group.jfif");
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.7) contrast(1.1) saturate(1.15);
  transform: scale(1.02);
  animation: subtleZoom 20s infinite alternate ease-in-out;
  border: 10px solid red;
`;

const BgOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:
    radial-gradient(
      circle at center,
      rgba(11, 15, 25, 0.25) 0%,
      rgba(7, 10, 18, 0.85) 100%
    ),
    linear-gradient(to bottom, rgba(15, 23, 42, 0.4), rgba(2, 6, 23, 0.85));
`;

const WorkContainer = styled.div`
  flex-direction: column;
  justify-content: start;
  align-items: start;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg-primary);
`;
